import request from '../../../helpers/request';

const bindTenantToRoom = async (data) => {
  await request.post(
    `/RentPlace/rental_house/office/tenant`,
    data,
    'При добавлении арендатора произошла ошибка'
  );
};

export default bindTenantToRoom;
